import script from "./SwitchViewButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchViewButtons.vue?vue&type=script&setup=true&lang=js"

import "./SwitchViewButtons.vue?vue&type=style&index=0&id=6e36d6cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e36d6cd"]])

export default __exports__